import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeGrey from "@/assets/icons/HomeGrey.svg";
import HomeWhite from "@/assets/icons/HomeWhite.svg";
import ChangelogWhite from "@/assets/icons/ChangelogWhite.svg";
import ChangelogGrey from "@/assets/icons/ChangelogGrey.svg";
import SettingsGrey from "@/assets/icons/SettingsGrey.svg";
import SettingsWhite from "@/assets/icons/SettingsWhite.svg";
import CardGrey from "@/assets/icons/CardGrey.svg";
import CardWhite from "@/assets/icons/CardWhite.svg";
import Bell from "@/assets/icons/Bell.svg";
import { profilePictures } from "@/lib/data";
import useUserData from "@/hooks/useUserData";
import UserDropdown from "./Reports/UserDropdown";
import { AnimatePresence } from "motion/react";
import { useOutsideClick } from "@/hooks/useOutsideClick";
import Notifications from "./Reports/Notifications";

const tabs = [
  {
    text: "Reports",
    href: "/dashboard",
    icon: HomeGrey,
    iconActive: HomeWhite,
  },
  // {
  //   text: "Surveys",
  //   href: "/surveys",
  // },
  {
    text: "Changelog",
    href: "/changelog",
    icon: ChangelogGrey,
    iconActive: ChangelogWhite,
  },
  {
    text: "Plans",
    href: "/plans",
    icon: CardGrey,
    iconActive: CardWhite,
  },
  {
    text: "Settings",
    href: "/settings",
    icon: SettingsGrey,
    iconActive: SettingsWhite,
  },
];

function DashboardSidebar() {
  const [currentTab, setCurrentTab] = useState(tabs[0].href);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showNotificationsDropdown, setShowNotificationsDropdown] =
    useState(false);
  const navigate = useNavigate();
  const { user } = useUserData();
  const profileRef = useRef(null);
  const notificationsRef = useRef(null);

  const location = useLocation();

  useOutsideClick(profileRef, () => {
    setShowUserDropdown(false);
  });

  useOutsideClick(notificationsRef, () => {
    setShowNotificationsDropdown(false);
  });

  useEffect(() => {
    if (location.pathname) {
      setCurrentTab(location.pathname);
    }
    if (location.pathname.includes("/dashboard")) {
      setCurrentTab("/dashboard");
    }
  }, [location.pathname]);

  return (
    <div className="flex z-[1000] flex-col w-[44px] shrink-0 fixed top-[64px] h-[calc(100vh-80px)]">
      <div className="flex-1" />
      <ul className="flex flex-col gap-2 justify-center">
        {tabs.map((tab, i) => {
          if (!user && i > 0) {
            return;
          }
          return (
            <li key={i} className={`w-[44px] h-[36px] cursor-pointer`}>
              <button
                className={`${
                  currentTab === tab.href ? "bg-gray-200" : ""
                } w-[44px] h-[36px] flex rounded-[12px] hover:bg-gray-300 transition-all items-center justify-center`}
                onClick={() => {
                  setCurrentTab(tab.href);
                  navigate(tab.href);
                }}
              >
                <img
                  src={currentTab === tab.href ? tab.iconActive : tab.icon}
                />
              </button>
            </li>
          );
        })}
      </ul>
      <div className="flex-1 flex flex-col items-center justify-end gap-2">
        {user && (
          <div ref={notificationsRef} className="relative z-[1000]">
            <button
              onClick={() => {
                setShowNotificationsDropdown((prev) => !prev);
              }}
              className="flex items-center justify-center rounded-[12px] hover:bg-gray-200 transition-all w-[44px] h-[36px]"
            >
              <img src={Bell} />
            </button>
            {user?.workspaceInvitations?.length > 0 && (
              <div className="w-2 h-2 absolute top-[9px] rounded-[50%] border-[1.5px] border-gray-200 right-[13px]">
                <div className="bg-red-700 rounded-[50%] w-full h-full" />
              </div>
            )}
            <AnimatePresence>
              {showNotificationsDropdown && <Notifications />}
            </AnimatePresence>
          </div>
        )}
        {user && (
          <div ref={profileRef} className="relative z-[1000]">
            <button
              onClick={() => {
                setShowUserDropdown((prev) => !prev);
              }}
              className="flex items-center justify-center rounded-[12px] hover:bg-gray-200 transition-all w-[44px] h-[36px]"
            >
              {user?.profilePicture ? (
                <img
                  src={profilePictures[user.profilePicture - 1]}
                  className="cursor-pointer border-[1px] w-[20px] h-[20px] border-white/[0.32] rounded-[50%]"
                />
              ) : (
                <div className="border-[1px] w-[21px] h-[21px] border-white/[0.55] rounded-[50%]" />
              )}
            </button>
            <AnimatePresence>
              {showUserDropdown && (
                <UserDropdown setIsOpen={setShowUserDropdown} />
              )}
            </AnimatePresence>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardSidebar;
